define('customPlugins/atnFastResetableArray',['knockout', 'lodash', './atnFastObservableArray'],
	function(ko, _) {
		'use strict';
		ko.atnFastResetableArray = function(commitedFastArray) {
			var resultFastArray = ko.atnFastObservableArray(_.clone(commitedFastArray(), true), commitedFastArray.keyFn);
			resultFastArray.commit = function() {
				copyFastArray(resultFastArray, commitedFastArray);
			};
			resultFastArray.reset = function() {
				copyFastArray(commitedFastArray, resultFastArray);
			};
			return resultFastArray;
		};
		return;

		function copyFastArray(source, destination) {
			destination.transaction(function(innerArray) {
				//	cleaning up destination array
				innerArray.splice(0, innerArray.length);
				// putting clone of source array
				innerArray.push(_.clone(source(), true));
			});
		}
	});
